<template>
  <!-- News Section -->
  <section class="news-section" id="news">
    <div class="container">
      <h2 class="section-title">{{ locale === 'tr' ? 'Haberler' : 'News' }}</h2>
      <p class="section-subtitle">{{ locale === 'tr' ? 'Son gelişmeler ve projelerimiz' : 'Latest developments and our projects' }}</p>
      <div class="news-grid">
        <div class="news-card" v-for="(article, index) in newsData" :key="article.id || index">
          <img 
            class="news-image" 
            :src="article.image"
            :alt="article.title"
            loading="lazy"
            @error="(e) => handleImageError(e, 'news')"
            @load="(e) => { imageCache.set(e.target.src, 'success'); loadingImages.delete(e.target.src) }"
          />
          <div class="news-content">
            <h3>{{ article.title }}</h3>
            <p class="news-date">{{ article.date }}</p>
            <p>{{ article.excerpt }}</p>
            <button class="news-btn">{{ locale === 'tr' ? 'Devamını Oku' : 'Read More' }}</button>
          </div>
        </div>
      </div>
      
      <!-- Debug info -->
      <div v-if="newsData.length === 0" class="news-debug" style="text-align: center; padding: 20px; background: #f5f5f5; margin: 20px 0;">
        <p>📊 Debug: newsData.length = {{ newsData.length }}</p>
        <p>🔄 isLoadingData = {{ isLoadingData }}</p>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { useNews } from '@/composables/useNews'

// Props
const props = defineProps({
  locale: {
    type: String,
    default: 'tr'
  }
})

// Computed locale
const locale = computed(() => props.locale)

// Composable kullanımı
const { 
  newsData, 
  isLoadingData,
  imageCache,
  loadingImages,
  handleImageError
} = useNews(locale)
</script>